<div class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">GÉRER MES CHOIX</div>
</div>

<div class="col-12 pt-3">
    <div>
        <strong>Transparence et confiance</strong>
        <br><br>
        Protéger vos données personnelles est un élément essentiel de notre relation. Ce portail vous permet de savoir
        ce que nous
        faisons de vos données personnelles et d'exercer vos droits.
        <br><br>
        <strong>Pourquoi souhaitons-nous utiliser vos données personnelles ?</strong>
        <br><br>
        <ul>
            <li>Pour mieux gérer vos comptes et vos services</li>
            <li>Pour améliorer la qualité des services qui vous sont propsés</li>
            <li>Pour vous conseiller des offres exclusives personnalisées</li>
        </ul>
        <br>
        Pour de plus amples informations vous pouvez consulter notre <a target="_blank"
                                                                        href="https://cdn.sfr-discover.fr/sources/sfr-discover/files/pdf/documentation/res/sfr_discover_politique_donnees_personnelles_07.05.2025.pdf">politique
        de protection des données personnelles</a>.
        <br><br>
    </div>
    <h2> Utilisation de vos données</h2>
    <div>
        <div class="accordion">
            @for (section of sections; track section) {
                <div class="accordion-item">
                    <button (click)="toggle(section)" class="accordion-header">
                        <span>{{ section.title }}</span>
                        <span class="arrow" [class.rotate]="section.open">▼</span>
                    </button>
                    @if (section.open && section.code === 'my data section') {
                        <div class="accordion-content">
                            Traitement des données à caractère personnel me concernant. J'accepte les finalités de
                            traitement détaillées ci-dessous:
                            <br><br>
                            @for (item of dataDetails; track item; let i = $index) {
                                <div class="sub-section">
                                    <div class="sub-section-header">
                                        <div class="text-content">
                                            <h4>{{ item.label }}</h4>
                                            <div [innerHTML]="item.content" class="description"></div>
                                        </div>
                                        <label class="switch">
                                            <input type="checkbox" [(ngModel)]="item.checked" name="checkbox{{i}}">
                                            <span class="slider round"></span>
                                        </label>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    @if (section.open && section.code === 'my contact section') {
                        <div class="accordion-content">
                            SFR utilise différents supports de communication, auxquels vous pouvez vous opposer en
                            plaçant les curseurs en position gauche.
                            Cette opposition ne s'applique pas aux communications nécessaires à l'exécution du contrat
                            ou obligations légales.
                            <!-- Premier bloc : les 4 premiers éléments -->
                            @for (item of contactDetails.slice(0, 4); track item; let i = $index) {
                                <div class="sub-section">
                                    <div class="sub-section-header">
                                        <div class="text-content">
                                            <h4>{{ item.label }}</h4>
                                        </div>
                                        <label class="switch">
                                            <input type="checkbox" [(ngModel)]="item.checked" name="checkbox{{i}}">
                                            <span class="slider round"></span>
                                        </label>
                                    </div>
                                </div>
                            }
                            <p class="bold-text">Vous pouvez également vous opposer au traitement suivant en plaçant le
                                curseur en position gauche :</p>
                            <div class="sub-section">
                                <div class="sub-section-header">
                                    <div class="text-content">
                                        <h4>{{ contactDetails[4].label }}</h4>
                                    </div>
                                    <label class="switch">
                                        <input type="checkbox" [(ngModel)]="contactDetails[4].checked" name="checkbox4">
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
        <br><br>
        <!-- Accordion: Exercer mes droits -->
        <div class="accordion">
            <div class="accordion-item">
                <button class="accordion-header" (click)="sectionOpen = !sectionOpen">
                    <span>Exercer mes droits</span>
                    <span>{{ sectionOpen ? '▲' : '▼' }}</span>
                </button>
                @if (sectionOpen) {
                    <div class="accordion-content">
                        <!-- A savoir -->
                        <div class="simple-sub-section">
                            <div class="sub-section-header">
                                <div class="text-content">
                                    <h4>À savoir</h4>
                                </div>
                            </div>
                            <div class="sub-section-body">
                                <strong>Cette rubrique vous permet:</strong>
                                <br>
                                - D'exercer votre droit d'accès sur les données personnelles vous concernat.
                                <br>
                                - Pour toute autre demande, merci de contacter votre service client SFR Discover
                                <br><br>
                                <strong>Cette rubrique ne permet pas:</strong>
                                <br>
                                - De vous opposer au démarchage téléphonique. Pour en savoir plus, consultez le site <a
                                    target="_blank" href="https://www.bloctel.gouv.fr/">BLOCTEL</a>
                                <br>
                                - De signaler la réception de SMS/d'appels téléphoniques indésirables sur votre mobile.
                                Pour en savoir plus, consultez le site: <a target="_blank" href="https://www.33700.fr/">www.33700.fr</a>
                                <br>
                                Pour vous permettre d'exercer au mieux vos droits, nous vous conseillons de consulter au
                                préable notre <a target="_blank"
                                                 href="https://cdn.sfr-discover.fr/sources/sfr-discover/files/pdf/documentation/res/sfr_discover_politique_donnees_personnelles_07.05.2025.pdf">politique
                                de protection des données personnelles</a>
                                disponible sur <a target="_blank"
                                                  href="https://www.sfr-discover.fr">www.sfr-discover.fr</a>
                            </div>
                        </div>
                        <!-- Gestion -->
                        <div class="simple-sub-section">
                            <div class="sub-section-header">
                                <div class="text-content">
                                    <h4>Gestion</h4>
                                </div>
                            </div>
                            <div class="sub-section-body">
                                <!-- Accordion: Accéder à mes données personnelles -->
                                <div class="accordion">
                                    <div class="accordion-item">
                                        <button class="accordion-header"
                                                (click)="accessDataSectionOpen = !accessDataSectionOpen">
                                            <span>Accéder à mes données personnelles</span>
                                            <span>{{ accessDataSectionOpen ? '▲' : '▼' }}</span>
                                        </button>
                                        @if (accessDataSectionOpen) {
                                            <div class="accordion-content">
                                                <!-- A savoir -->
                                                <div class="simple-sub-section">
                                                    <div class="sub-section-header">
                                                        <div class="text-content">
                                                            <h4>À savoir</h4>
                                                        </div>
                                                    </div>
                                                    <div class="sub-section-body">
                                                        <strong>Cette rubrique vous permet:</strong>
                                                        <br>
                                                        - D'obtenir l'accès aux données personnelles vous concernant que
                                                        nous traitons.
                                                        <br>
                                                        Pour toute autre demande, merci de contacter votre service
                                                        client SFR Discover
                                                        <br><br>
                                                        <strong>Cette rubrique ne permet pas:</strong>
                                                        <br>
                                                        - De demander la récupération d'anciennes factures (celles-ci
                                                        sont disponibles dans la rubrique factures)
                                                        <br>
                                                        - De récupérer les données supprimées par erreur sur vos
                                                        téléphones portable, cloud... (mails,contacts...)
                                                        <div class="alert-box">
                                                            <div class="alert-icon">⚠️</div>
                                                            <div class="alert-content">
                                                                <p>
                                                                    Veuillez vous assurer que vous avez autorisé SFR à
                                                                    vous contacter par <strong>courrier</strong>
                                                                    électronique ou <strong>SMS</strong> et que vos
                                                                    coordonnées de contact sont à jour. À défaut, nous
                                                                    ne serons pas en mesure de vous adresser cette
                                                                    <strong>notification</strong>.
                                                                </p>
                                                                <p>
                                                                    <a href="#">Vérifier mes préférences de
                                                                        contact</a><br>
                                                                    <a href="#">Accéder à mes coordonnées de contact</a>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- Accès à mes données personnelles -->
                                                <div class="simple-sub-section">
                                                    <div class="sub-section-header">
                                                        <div class="text-content">
                                                            <h4>Accès à mes données personnelles</h4>
                                                        </div>
                                                    </div>
                                                    <div class="sub-section-body">
                                                        Dans les conditions fixées par la Réglementation en vigeur, vous
                                                        pouvez sollliciter l'accès à vos données à caractère personnel
                                                        faisant l'objet d'un traitement par SFR.
                                                        Votre demande sera traitée sous un mois. Ce delai pourra être
                                                        prolongé de deux mois en cas de demande complexe ou récurrente.
                                                        <br>
                                                        <div class="rgpd-section">
                                                            <div class="checkbox-container">
                                                                <input type="checkbox" id="personalDataAccess"
                                                                       name="personalDataAccess"
                                                                       [(ngModel)]="customerRgpdInterface.personalDataAccess"
                                                                       (change)="onPersonalDataAccessCheckboxChange($event)">
                                                                <label for="personalDataAccess">J'atteste sur l'honneur
                                                                    être la personne concernée par l'exercice de ce
                                                                    droit.</label>
                                                            </div>
                                                            @if (showPopup) {
                                                                <div class="popup-inline">
                                                                    <h2>Vous êtes sur le point de transmettre votre
                                                                        demande</h2>
                                                                    <p>
                                                                        Vous recevrez une notification lorsque le
                                                                        rapport contenant vos données personnelles sera
                                                                        prêt à être téléchargé.
                                                                        Il restera disponible au téléchargement pendant
                                                                        un mois.
                                                                    </p>
                                                                    <p>Confirmez-vous votre demande ?</p>
                                                                    <div class="popup-actions">
                                                                        <button class="btn-secondary-btn"
                                                                                (click)="cancelPopup()">Non
                                                                        </button>
                                                                        <button class="btn-primary-btn"
                                                                                (click)="confirmPopup()">Oui
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <br/>
                                <!-- Accordion: Rectifier mes données personnelles -->
                                <div class="accordion">
                                    <div class="accordion-item">
                                        <button class="accordion-header"
                                                (click)="correctDataSectionOpen = !correctDataSectionOpen">
                                            <span>Rectifier mes données personnelles</span>
                                            <span>{{ correctDataSectionOpen ? '▲' : '▼' }}</span>
                                        </button>
                                        @if (correctDataSectionOpen) {
                                            <div class="accordion-content">
                                                <!-- A savoir -->
                                                <div class="simple-sub-section">
                                                    <div class="sub-section-header">
                                                        <div class="text-content">
                                                            <h4>À savoir</h4>
                                                        </div>
                                                    </div>
                                                    <div class="sub-section-body">
                                                        <strong>Cette rubrique vous permet:</strong>
                                                        <br>
                                                        - De consulter, mettre à jour et, si nécessaire, de rectifier
                                                        vos coordonnées (nom, prénom, coordonnées postales,
                                                        téléphoniques et informations bancaires).
                                                        <br>
                                                        Pour toute autre demande, merci de contacter votre service
                                                        client SFR Discover
                                                        <br><br>
                                                        <strong>Cette rubrique ne permet pas:</strong>
                                                        <br>
                                                        - De modifier vos dates et lieu de naissance. Pour mettre à jour
                                                        ces données, merci de contacter votre service client.
                                                    </div>
                                                </div>
                                                <!-- Utilisation de vos données personnelles -->
                                                <div class="simple-sub-section">
                                                    <div class="sub-section-header">
                                                        <div class="text-content">
                                                            <h4>Utilisation de vos données personnelles</h4>
                                                        </div>
                                                    </div>
                                                    <div class="sub-section-body">
                                                        <strong>Rectifier mes données personnelles</strong>
                                                        <br>
                                                        Dans les conditions fixées par la Règlementation en vigueur,
                                                        vous pouvez rectifier les données à caractère personnel faisant
                                                        l’objet d’un traitement par SFR.
                                                        Pour prendre connaissance de vos informations personnelles et si
                                                        nécessaire les modifier, rendez-vous dans la rubrique
                                                        <a href="/compte/infos">« Mes infos »</a>.
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <br/>
                                <!-- Accordion: Effacer mes données personnelles -->
                                <div class="accordion">
                                    <div class="accordion-item">
                                        <button class="accordion-header"
                                                (click)="deleteDataSectionOpen = !deleteDataSectionOpen">
                                            <span>Effacer mes données personnelles</span>
                                            <span>{{ deleteDataSectionOpen ? '▲' : '▼' }}</span>
                                        </button>
                                        @if (deleteDataSectionOpen) {
                                            <div class="accordion-content">
                                                <!-- A savoir -->
                                                <div class="simple-sub-section">
                                                    <div class="sub-section-header">
                                                        <div class="text-content">
                                                            <h4>À savoir</h4>
                                                        </div>
                                                    </div>
                                                    <div class="sub-section-body">
                                                        <strong>Cette rubrique vous permet:</strong>
                                                        <br>
                                                        - De demander l'effacement de vos données à caractère personnel
                                                        (dans la mesure où cela n'empêche pas la bonne exécution du
                                                        contrat ou le respect des obligations légales
                                                        de SFR).
                                                        <br><br>
                                                    </div>
                                                </div>
                                                <!-- Effacer mes données personnelles -->
                                                <div class="simple-sub-section">
                                                    <div class="sub-section-header">
                                                        <div class="text-content">
                                                            <h4>Effacer mes données personnelles</h4>
                                                        </div>
                                                    </div>
                                                    <div class="sub-section-body">
                                                        <strong>Rectifier mes données personnelles</strong>
                                                        <br>
                                                        Rectifier mes données personnelles en vigueur, vous pouvez
                                                        demander l'effacement de vos données à caractère personnel
                                                        faisant l’objet d’un traitement par SFR
                                                        pour les motifs suivants :
                                                        <br>
                                                        - Vous vous êtes opposé au traitement de vos données
                                                        personnelles à des fins de prospection ou en raison de votre
                                                        situation particulière.
                                                        <br>
                                                        -Vous avez retiré le consentement sur lequel était fondé le
                                                        traitement.
                                                        <br><br>
                                                        L'exercice de ce droit ne fait pas obstacle à la conversations
                                                        ultérieure des données à caractère personnel lorsque celle-ci
                                                        est nécessaire à l'exercice du droit
                                                        à la liberté d'expression et d'information ou au respect d'une
                                                        obligation légale ou contractuelle s'imposant à SFR.
                                                        <br>
                                                        <div class="checkbox-container">
                                                            <input type="checkbox" id="deleted" name="deleted"
                                                                   [(ngModel)]="customerRgpdInterface.deleted">
                                                            <label for="deleted">J'atteste sur l'honneur être la
                                                                personne concernée par l'exercice de ce droit.</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>

    <div class="w-100 mt-3 cta_container text-center">
        <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
        <button type="submit" class="cta_btn level_2 column" (click)="save()">Valider<span></span></button>
    </div>
</div>